import { render, staticRenderFns } from "./mandates.vue?vue&type=template&id=56234c7f&scoped=true&"
import script from "./mandates.vue?vue&type=script&lang=js&"
export * from "./mandates.vue?vue&type=script&lang=js&"
import style0 from "./mandates.vue?vue&type=style&index=0&id=56234c7f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56234c7f",
  null
  
)

export default component.exports